import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createInquiry } from "@/services/rest/inquiry-management";
import { InquiryRequest } from "@/types/service-inquiry";

export const useCreateInquiry = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: InquiryRequest) => createInquiry(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-inquiries"] });
    },
  });
};
